import moment from "moment/moment";
import React, { useState } from "react";
import { Row } from "react-bootstrap";
import DatePicker from "react-datepicker";
import ReactPaginate from "react-paginate";
import { useNavigate } from "react-router-dom";
import { editIcon, viewIcon } from "../../assets/img";

const FinancialDetails = ({
  details,
  getTransactions,
  transactionList,
  setTransactionPage,
  transactionRow,
  transactionFrom_date,
  transactionTo_date,
  transactionCount,
  pagonationTransaction,
}) => {
  const navigate = useNavigate();

  const handlePageChange = (selectedObject) => {
    setTransactionPage(selectedObject.selected + 1);
  };
  return (
    <div>
      {" "}
      <Row md={12} sm={12} lg={12}>
        <div className="col-md-6 mt-2">
          <label className="table-labels f1">
            Total Count : {pagonationTransaction?.total}
          </label>
        </div>
      </Row>
      <div className="d-flex ac-jb ">
        <div className="col-md-3 mb-2 p-0">
          <select
            className="form-control custom-select"
            onChange={(e) =>
              getTransactions(
                e.target.value,
                transactionFrom_date,
                transactionTo_date
              )
            }
            value={transactionRow}
          >
            <option value={10}>10</option>
            <option value={25}>25</option>
            <option value={50}>50</option>
            <option value={100}>100</option>
          </select>
        </div>
        <div className="col-md-4 mb-2 p-0">
          <DatePicker
            selected={transactionFrom_date}
            onChange={(date) => {
              getTransactions(transactionRow, date, transactionTo_date);
            }}
            peekNextMonth
            showMonthDropdown
            showYearDropdown
            dropdownMode="select"
            dateFormat="yyyy-MM-dd"
            todayButton="Today"
            className="form-control custom-select"
            placeholderText="YYYY-MM-DD"
          />
        </div>
        <div className="col-md-4 mb-2 p-0">
          <DatePicker
            selected={transactionTo_date}
            onChange={(date) => {
              getTransactions(transactionRow, transactionFrom_date, date);
            }}
            peekNextMonth
            showMonthDropdown
            showYearDropdown
            dropdownMode="select"
            dateFormat="yyyy-MM-dd"
            todayButton="Today"
            className="form-control custom-select"
            placeholderText="YYYY-MM-DD"
          />
        </div>
      </div>
      <div className="table-custom-design overflow-scroll">
        <table>
          <thead className="single-book-table">
            <tr className="text-capitalize text-nowrap">
              <th>S.NO</th>
              <th>Date</th>
              <th>Property Name</th>
              <th>Type</th>
              <th>Booking ID</th>
              <th>Transaction type</th>
              <th>Transaction Amount</th>
            </tr>
          </thead>
          <tbody>
            {transactionList?.map((item, ind) => {
              return (
                <tr key={ind}>
                  <td>
                    {(pagonationTransaction?.current_page - 1) *
                      transactionRow +
                      ind +
                      1}
                  </td>
                  <td>
                    {item?.created_at
                      ? moment(item?.created_at).format("DD-MM-YYYY hh:mm a")
                      : "-"}
                  </td>
                  <td>
                    <button
                      className="link-btn"
                      onClick={() => {
                        let obj = {
                          id: item?.pid,
                          ...item,
                        };
                        navigate("/property-view", {
                          state: { type: "edit", data: obj },
                        });
                      }}
                    >
                      {item?.property_name}
                    </button>
                  </td>
                  <td>{item?.display_type}</td>
                  <td>
                    <button
                      className="link-btn"
                      onClick={() => {
                        let obj = {
                          id: item?.page_id,
                          ...item,
                        };
                        navigate("/booked-rooms-view", {
                          state: { data: obj },
                        });
                      }}
                    >
                      {item?.booking_id}
                    </button>
                  </td>
                  <td>{item?.type}</td>
                  <td>{item?.total_amount}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
      <div className="page-inner-cont py-2 d-flex justify-content-end">
        <ReactPaginate
          nextLabel="››"
          onPageChange={handlePageChange}
          pageRangeDisplayed={2}
          marginPagesDisplayed={2}
          pageCount={transactionCount}
          previousLabel="‹‹"
          pageClassName="page-item"
          pageLinkClassName="page-link"
          previousClassName="page-item"
          previousLinkClassName="page-link"
          nextClassName="page-item"
          nextLinkClassName="page-link"
          breakLabel="..."
          breakClassName="page-item"
          breakLinkClassName="page-link"
          containerClassName="pagination"
          activeClassName="active"
          renderOnZeroPageCount={null}
        />
      </div>
    </div>
  );
};

export default FinancialDetails;
